<template>
  <div id="app" :data-title="textTitle">
    <router-view/>
  </div>
</template>
<script>
export default {
  created () {
    document.title = '中宝AI药师'
  },
  data() {
    return {
      textTitle: '中宝AI药师'
    }
  }
}
</script>
<style lang="css" src="./assets/common.css">
</style>
